<template>
  <div class="admin-page">
    <h1 class="page-title">管理员</h1>
    <AdminPrizePoolSection />
    <AdminNodeSection />
    <AdminShippingSection />
  </div>
</template>

<script>
import AdminPrizePoolSection from "./admin/components/AdminPrizePoolSection.vue";
import AdminNodeSection from "./admin/components/AdminNodeSection.vue";
import AdminShippingSection from "./admin/components/AdminShippingSection.vue";

export default {
  name: "AdminView",
  components: {
    AdminPrizePoolSection,
    AdminNodeSection,
    AdminShippingSection,
  },
};
</script>

<style lang="scss" scoped>
.admin-page {
  min-height: 100%;
  box-sizing: border-box;
  padding: 0 32px 32px;
  padding-bottom: calc(32px + env(safe-area-inset-bottom, 0px));
  color: #333;
}

.page-title {
  margin: 0 0 28px;
  font-size: 36px;
  font-weight: 700;
  color: #1a1a1a;
}
</style>
